<div #svgContainer [innerHTML]="svgBody$ | async"></div>
